<template>
  <AppCard
    elevation="0"
    class="SubscriptionConsumptionDrPpu"
    data-locator="subscription-consumption-pay-per-use-plan"
  >
    <div class="SubscriptionConsumptionDrPpu__content">
      <h3
        class="mb-1 text--x-large font-weight-bold text-text-primary"
        data-locator="subscription-consumption-pay-per-use-plan-title"
      >
        {{ $t(`${TRANSLATION_KEY_PREFIX}.title`) }}
      </h3>
      <p class="mb-0 text--small text-text-secondary">
        {{ $t(`${TRANSLATION_KEY_PREFIX}.subtitle`) }}
      </p>
    </div>

    <app-button
      type="primary"
      class="SubscriptionConsumptionDrPpu__cta"
      data-locator="subscription-consumption-pay-per-use-plan-open-dataroom"
      @click="newDataroomDialogIsOpen = true"
    >
      {{ $t(`${TRANSLATION_KEY_PREFIX}.openDataroom`) }}
    </app-button>

    <!-- DIALOGS -->
    <ProjectsNewDataroomDialog
      v-if="newDataroomDialogIsOpen"
      :isOpenedFromHome="false"
      @requestActivation="openQuoteRequestDialog"
      @close="newDataroomDialogIsOpen = false"
    />
  </AppCard>
</template>

<script>
  import { mapMutations } from 'vuex'

  import lexisLogo from '@/assets/img/subscription/lexisnexis-logo.svg'
  import AppCard from '@/common/AppCard.vue'
  import { QUOTE_REQUEST_TOPICS } from '@/common/utils/quoteRequestTopics'
  import ProjectsNewDataroomDialog from '@/projects/dialogs/ProjectsNewDataroomDialog.vue'
  import { SET_PROJECT_TYPE_QUOTE_REQUEST_DIALOG } from '@/store/modules/subscription/mutation_types'

  const TRANSLATION_KEY_PREFIX = 'subscriptions.views.SubscriptionConsumption.PayPerUsePlan'

  export default {
    name: 'SubscriptionConsumptionDrPpu',
    components: { AppCard, ProjectsNewDataroomDialog },
    data () {
      return {
        TRANSLATION_KEY_PREFIX,
        logoBackground: `url(${lexisLogo})`,
        newDataroomDialogIsOpen: false,
      }
    },
    methods: {
      ...mapMutations('subscription', [SET_PROJECT_TYPE_QUOTE_REQUEST_DIALOG]),
      openQuoteRequestDialog () {
        this.SET_PROJECT_TYPE_QUOTE_REQUEST_DIALOG({
          isOpen: true,
          defaultProjectType: QUOTE_REQUEST_TOPICS.DATAROOM,
        })
      },
    },
  }
</script>

<style scoped lang="scss">
  .SubscriptionConsumptionDrPpu {
    display: flex;
    flex-direction: column;
    min-height: 200px;
    background-color: rgb(var(--v-theme-surface-tertiary));
    background-image: v-bind(logoBackground);
    background-repeat: no-repeat;
    background-position: right bottom;
  }

  :deep(.SubscriptionConsumptionDrPpu__cta) {
    align-self: flex-start;
    margin-top: auto;
  }
</style>
